export default "__VITE_ASSET__7db29120__"